// extracted by mini-css-extract-plugin
module.exports = {"reminder":"jgp-pbtwg"};